import { useEffect } from "react";
import { Bookmark } from "lucide-react";
import { useAuth } from "../lib/auth";
import { ensureSavedLoaded, toggleSaved, useIsSaved } from "../lib/saved";

/** Bookmark toggle for any listing (item, service, company, person, job, project, rfq).
 *  Icon-only by default; pass `label` to render a full button (e.g. detail-page CTA). */
export function SaveButton({ kind, refId, className = "", label }: { kind: string; refId: string; className?: string; label?: string }) {
  const { user } = useAuth();
  const saved = useIsSaved(kind, refId);
  useEffect(() => { if (user) ensureSavedLoaded(); }, [user]);
  if (!user) return null;
  if (label) {
    return (
      <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSaved(kind, refId); }}
        className={`btn-outline ${saved ? "text-brand-red" : ""} ${className}`}>
        <Bookmark className={`w-4 h-4 ${saved ? "fill-brand-red" : ""}`} />{saved ? "Saved" : label}
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggleSaved(kind, refId); }}
      title={saved ? "Saved — click to remove" : "Save"}
      aria-label={saved ? "Remove from saved" : "Save"}
      className={`grid place-items-center rounded-lg transition-colors ${saved ? "text-brand-red" : "text-mut hover:text-navy"} ${className}`}
    >
      <Bookmark className={`w-4 h-4 ${saved ? "fill-brand-red" : ""}`} />
    </button>
  );
}
